var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClaimCreate',{attrs:{"cancellation-popup-data":_vm.cancellationPopupData}},[_c(_vm.currentView,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }